import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDoordash = function SvgDoordash(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M22.945 24.523h-3.92a1.852 1.852 0 0 1-.7-.137 1.76 1.76 0 0 1-.317-.168c-.1-.065-.193-.14-.28-.227l-3.884-3.857a.591.591 0 0 1-.168-.31.58.58 0 0 1 .036-.349.596.596 0 0 1 .224-.272.597.597 0 0 1 .162-.075.563.563 0 0 1 .176-.028h8.667a1.612 1.612 0 0 0 1.605-1.617A1.608 1.608 0 0 0 22.91 15.9H10.339c-.487 0-.954-.191-1.296-.532L5.16 11.511a.592.592 0 0 1-.166-.309.62.62 0 0 1-.01-.177.611.611 0 0 1 .606-.548h17.83a6.362 6.362 0 0 1 5.63 3.325c2.848 5.34-1.008 10.72-6.105 10.72Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgDoordash;